import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

interface TestSsoParams {
  redirect_uri?: string;
}

interface TestSsoResponse {
  authorization_url: string;
  state: string;
}

/**
 * Start a Test-SSO round-trip. Returns an authorization URL the caller
 * opens in a new tab; the SSO callback recognises the `test_sso:...`
 * state token and renders the result without minting a session.
 */
export const useTestSso = (organizationId: number) => {
  const userToken = useAuth()?.userToken;
  return useMutation({
    mutationFn: async (params: TestSsoParams = {}): Promise<TestSsoResponse> =>
      fetch(ENDPOINTS.identity.test_sso(organizationId), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken ?? ""}`,
        },
        body: JSON.stringify({
          redirect_uri: params.redirect_uri ?? `${window.location.origin}/auth/sso/callback`,
        }),
      }).then(handleResponse),
  });
};
